import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { S3StaticDatumsEdit } from "./edit";
import { S3StaticDataNew } from "./new";
import { S3StaticDatumsTable } from "./table";
export default function S3StaticDatums() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Actifs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<S3StaticDatumsEdit />} />
      <Route index element={<S3StaticDatumsTable />} />
      <Route path="/new" element={<S3StaticDataNew />} />
    </Routes>
  );
}
